import { Component, h } from 'preact';
import { TcrUserTile } from './user-tile';
import { TcrMenuView } from './menu-view';

class TcrMenuBar extends Component
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        if (!this.props.config || !this.props.config.visible) return;

        let userTile;
        if (this.props.config.userTile)
        {
            userTile = <TcrUserTile visibility={this.props.config.userTile.visible} actions={this.props.config.userTile.actions} initials="" title={this.props.config.userTile.title} subtitle={this.props.config.userTile.subtitle} accent={this.props.config.userTile.accent}/>;
        }

        return (
            <div class="menu-bar" data-menu={this.props.showMenu}>
                {userTile}
                <TcrMenuView menu={this.props.config.menuItems} onClose={this.props.onClose} />
                <div class="overlay"></div>
                <div class="overlay2"></div>
            </div>
        );
    }
}

export { TcrMenuBar };
